module.exports = __webpack_public_path__ + "img/制御工学8_8.72b5d08a.png";